import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Temples from './pages/Temples';
import TempleDetails from './pages/TempleDetails';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Forum from './pages/Forum';
import Polls from './pages/Polls';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

// New Imports
import Login from './pages/Login.jsx';
import Signup from './pages/Signup.jsx';
import WriteBlog from './pages/WriteBlog';
import ProtectedRoute from './components/ProtectedRoute';
import Panchang2026 from './pages/panchang-2026';

// CMS Imports
import CmsLayout from './cms/CmsLayout';
import Dashboard from './cms/Dashboard';
import ManageBlogs from './cms/ManageBlogs';
import ManageAds from './cms/ManageAds';
import ManageUsers from './cms/ManageUsers';
import ManageTemples from './cms/ManageTemples';
import ManageOtherTemples from './cms/ManageOtherTemples';
import ManageSettings from './cms/ManageSettings';
import ManageAboutUs from './cms/ManageAboutUs';
import ManagePolls from './cms/ManagePolls';

import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        
        {/* PUBLIC SYSTEM (Wrapped in Main Website Layout) */}
        <Route element={<Layout><Outlet /></Layout>}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/temples" element={<Temples />} />
          <Route path="/temple/:id" element={<TempleDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/polls" element={<Polls />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/panchang-2026" element={<Panchang2026 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          
          {/* Protected Public Routes */}
          <Route path="/write" element={
            <ProtectedRoute>
              <WriteBlog />
            </ProtectedRoute>
          } />
        </Route>

        {/* CMS SYSTEM (Wrapped in isolated Admin Layout) */}
        <Route path="/admin" element={
          <ProtectedRoute>
            <CmsLayout>
              <Outlet />
            </CmsLayout>
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="temples" element={<ManageTemples />} />
          <Route path="other-temples" element={<ManageOtherTemples />} />
          <Route path="blogs" element={<ManageBlogs />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="ads" element={<ManageAds />} />
          <Route path="polls" element={<ManagePolls />} />
          <Route path="settings" element={<ManageSettings />} />
          <Route path="about" element={<ManageAboutUs />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;